import {createContext, useEffect, useState} from 'react'


const authDefault = {
    isAuthenticated: false,
    dataUser: null
}


export const AuthContext = createContext({
    authInfo: authDefault,
    setDataUser: (dataUser) => {
    },
    loading: false,
    notiMessage: '',
    setNotiMessage: () => {}
})

const AuthContextProvider = ({children}) => {
    const [authInfo, setAuthInfo] = useState(authDefault);
    const [loading, setLoading] = useState(true);
    const [notiMessage, setNotiMessage] = useState(null)
    // const [notiMessageInfo, setNotiMessageInfo] = useState(null)

    const applyBillingWarning = (dataUser) => {
        if (!dataUser) return dataUser;
        const day = new Date().getDate();
        if (day === 13 || day === 14) {
            return {
                ...dataUser,
                warningMsg: "O sistema está prestes a vencer. Vence dia 15, efetue o pagamento."
            };
        }
        return dataUser;
    };

    useEffect(() => {
        try {
            const dataUserParse = localStorage.getItem("dataUser");
            if (dataUserParse) {
                const dataUserInitial = JSON.parse(dataUserParse);
                if (dataUserInitial) {
                    setAuthInfo({
                        isAuthenticated: true,
                        dataUser: applyBillingWarning(dataUserInitial)
                    })
                } else {
                    setAuthInfo({
                        isAuthenticated: false,
                        dataUser: null
                    })
                }
            } else {
                setAuthInfo({
                    isAuthenticated: false,
                    dataUser: null
                })
            }
        } catch (e) {
            setAuthInfo({
                isAuthenticated: false,
                dataUser: null
            })
        }
        setLoading(false);
    }, [])

    const setDataUser = (dataUser) => {
        if (dataUser) {
            const dataUserWithWarning = applyBillingWarning(dataUser);
            localStorage.setItem("dataUser", JSON.stringify(dataUserWithWarning));
            setAuthInfo({
                isAuthenticated: true,
                dataUser: dataUserWithWarning
            })
        } else {
            localStorage.removeItem("dataUser")
            setAuthInfo({
                isAuthenticated: false,
                dataUser: dataUser
            })
        }
    }

    const authContextData = {
        authInfo,
        loading,
        setDataUser,
        notiMessage,
        setNotiMessage,
        // notiMessageInfo,
        // setNotiMessageInfo
    }

    return (
        <AuthContext.Provider value={authContextData}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider
